import { ConsumerAuthForm } from "@/components/auth/ConsumerAuthForm";

export function LoginModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-end justify-center bg-black/70 backdrop-blur-sm animate-in fade-in duration-200"
      role="dialog"
      aria-modal="true"
      aria-labelledby="login-modal-title"
    >
      <ConsumerAuthForm variant="modal" onSuccess={onClose} />
    </div>
  );
}
